import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/arrow_down_black.png")